const ContactAttributeType = `
  id
  description
`;

export default ContactAttributeType;
